export class TableContextSegment {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "condition",
            "baseName": "condition",
            "type": "string",
            "format": ""
        },
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        },
        {
            "name": "share",
            "baseName": "share",
            "type": "number",
            "format": ""
        },
        {
            "name": "rows",
            "baseName": "rows",
            "type": "number",
            "format": ""
        },
        {
            "name": "sampledRows",
            "baseName": "sampledRows",
            "type": "number",
            "format": ""
        },
        {
            "name": "outcome",
            "baseName": "outcome",
            "type": "string",
            "format": ""
        },
        {
            "name": "finding",
            "baseName": "finding",
            "type": "string",
            "format": ""
        },
        {
            "name": "implied",
            "baseName": "implied",
            "type": "string",
            "format": ""
        },
        {
            "name": "firstSeen",
            "baseName": "firstSeen",
            "type": "string",
            "format": "date"
        },
        {
            "name": "conditions",
            "baseName": "conditions",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextSegment.attributeTypeMap;
    }
    constructor() {
    }
}
